import React from "react";
import PropTypes from "prop-types";
import { createSelector, createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

const createGridItem = (title, subtitle, data) => (
  <Grid key={title.replace(/\s/g, "")} item style={{ minWidth: "250px" }}>
    <Card
      style={{
        margin: 20,
        minHeight: 250,
        borderRadius: 10,
        boxShadow: "rgba(0, 0, 0, 0.36) 1px 10px 25px 3px"
      }}
    >
      <CardContent
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Typography variant="h5" component="h2" style={{ textAlign: "center" }}>
          {title}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {subtitle}
        </Typography>
        <List>
          {data.map(d => (
            <Typography key={d} variant="body2" component="div">
              {d}
            </Typography>
          ))}
        </List>
      </CardContent>
    </Card>
  </Grid>
);

const LandingPage = props => (
  <div>
    <Typography variant="h2" style={{ textAlign: "center" }}>
      Welcome to the portal! <br />
    </Typography>
    <Typography variant="h4" style={{ textAlign: "center", margin: 20 }}>
      Choose an option from the sidebar to get started. <br />
    </Typography>
    <hr
      style={{
        width: "100%",
        border: "0px",
        height: "1.5px",
        backgroundImage:
          "linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0))",
        marginBottom: "60px"
      }}
    />
    {!(props.allowedOrganizations.length && props.allowedWorkareas.length) && (
      <Typography style={{ textAlign: "center", margin: "5px" }}>
        <WarningIcon />
        <b>
          You need access to organizations and workareas to be able to upload
          and download data from the portal. Please contact
          eims.support@hakai.org to request access.
        </b>
      </Typography>
    )}
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container justify="center" alignItems="center" spacing={3}>
          {createGridItem(
            "Organizations",
            "You can upload data as:",
            props.allowedOrganizations
          )}
          {createGridItem(
            "Workareas",
            "You have access to:",
            props.allowedWorkareas
          )}
          {createGridItem("Get support", null, [
            <Typography variant="subtitle1">
              EIMS issues (portal, data, database):
            </Typography>,
            <Link
              href="mailto:eims.support@hakai.org"
              target="_blank"
              color="inherit"
              style={{ paddingLeft: 20 }}
            >
              eims.support@hakai.org
            </Link>,
            <Typography>
              IT issues (computer hardware and software):
            </Typography>,
            <Link
              href="mailto:support@hakai.org"
              target="_blank"
              color="inherit"
              style={{ paddingLeft: 20 }}
            >
              support@hakai.org
            </Link>
          ])}
        </Grid>
      </Grid>
    </Grid>
  </div>
);

LandingPage.defaultProps = {};
LandingPage.propTypes = {
  allowedOrganizations: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowedWorkareas: PropTypes.arrayOf(PropTypes.string).isRequired
};

export const allowedWorkareaSelector = createSelector(
  state => state.auth.getIn(["user", "workareas"]),
  f => (f ? f.toJS() : []) // return empty array if undefined
);
export const allowedOrganizationSelector = createSelector(
  state => state.auth.getIn(["user", "organizations"]),
  f => (f ? f.toJS() : []) // return empty array if undefined
);

const landingPageStateToProps = createStructuredSelector({
  allowedWorkareas: allowedWorkareaSelector,
  allowedOrganizations: allowedOrganizationSelector
});

export default withRouter(connect(landingPageStateToProps)(LandingPage));
